<template lang="pug">
div
  app-divider(label="Imóvel")
  el-row.pad5
    el-col(:span="12")
      p
        span.label {{labelsCadastro.imovel.denominacao}}
        span.breakText &nbsp {{filterNull(imovel.denominacao)}}
    el-col(:span="12")
      p
        span.label {{labelsCadastro.imovel.colonia}}
        span.breakText &nbsp {{filterNull(imovel.gleba)}}
    el-col(:span="12")
      p
        span.label Área:
        span.breakText &nbsp {{formatterNumber(imovel.area, imovel.tipoArea)}}
    el-col(:span="12")
      p
        span.label Município:
        span.breakText &nbsp {{filterMunicipioNull(imovel.municipio)}}
    el-col(:span="12")
      p
        span.label Latitude:
        span.breakText &nbsp {{filterNull(imovel.latitude)}}
    el-col(:span="12")
      p
        span.label Longitude:
        span.breakText &nbsp {{filterNull(imovel.longitude)}}
    el-col(:span="12")
      p
        span.label Logradouro:
        span.breakText &nbsp {{filterNull(imovel.logradouro)}}
    el-col(:span="12")
      p
        span.label Número:
        span.breakText &nbsp {{filterNull(imovel.numero)}}
    el-col(:span="12")
      p
        span.label Bairro:
        span.breakText &nbsp {{filterNull(imovel.bairro)}}
    el-col(:span="12")
      p
        span.label Localizacao:
        span.breakText &nbsp {{filterNull(imovel.localizacao)}}
  app-divider(label="Dados do registro")
  el-row.pad5
    el-col(:span="12")
      p
        span.label Matrícula:
        span.breakText &nbsp {{filterNull(imovel.numeroMatricula)}}
    el-col(:span="12")
      p
        span.label Livro:
        span.breakText &nbsp {{filterNull(imovel.livroMatricula)}}
    el-col(:span="12")
      p
        span.label Folha:
        span.breakText &nbsp {{filterNull(imovel.numeroFolhaMatricula)}}
    el-col(:span="12")
      p
        span.label Nome do cartório:
        span.breakText &nbsp {{filterNull(imovel.nomeCartorio)}}
    el-col(:span="12")
      p
        span.label Município do cartório:
        span.breakText &nbsp {{filterNull(imovel.municipioCartorio.nome)}}
  app-resumo-documentos.margin-top(:documentos="imovel.documentos" codigoCadastro="imovel", :idCadastro="idCadastro", :isProcessoFisico="true")
</template>
<script>
import utils from '@/utils/utils'
import AppDivider from '@/components/AppDivider'
import AppResumoDocumentos from '@/components/resumo/AppResumoDocumentos'
const {labelsCadastro, inputsExtraCadastro, tiposArea} = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default

export default {
  components: {
    AppDivider,
    AppResumoDocumentos
  },
  data () {
    return {
      labelsCadastro,
      inputsExtraCadastro
    }
  },
  props: {
    imovel: {
      type: Object,
      required: true
    },
    idCadastro: {
      type: Number,
      required: true
    },
    hasFieldsExtras: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  methods: {
    filterNull (atributo) {
      if (!atributo || atributo.length === 0) {
        return '-'
      }
      return atributo
    },
    filterMunicipioNull (municipio) {
      return municipio ? municipio.nome : '-'
    },
    formatterNumber (value, tipoArea) {
      const options = {
        prefix: '',
        suffix: '',
        thousands: '.',
        decimal: ',',
        precision: 4
      }
      let tipoAreaObj = tiposArea.find(item => item.codigo === tipoArea)
      let tipoAreaNome = ''

      if (tipoAreaObj) {
        tipoAreaNome = tipoAreaObj.nome
      }

      return value > 0 ? utils.format(value, options) + ' ' + tipoAreaNome : '-'
    },
    formatDate (value) {
      return value ? utils.formatDate(value) : '-'
    }
  }
}
</script>
<style lang="scss" scoped>
.label {
  font-weight: bold;
}
.pad5 {
  padding: 25px 10px;
}

.margin-top {
  margin-top: 25px;
}

.breakText {
  word-break: break-all;
}

@media (max-width: 780px) {
  .pad5 {
    display: flex;
    flex-direction: column;
    width: 460px;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/maranhao/processoFisico/components/ResumoImovel.vue